import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { clearPendingReleaseLogin } from "../../core/utils/pendingReleaseLogin";
import { clearPendingSmsLogin } from "../../core/utils/pendingSmsLogin";
import { LoadingScreen } from "./LoadingScreen";
import { handleLogout } from "./utils/handleLogout";
import { useApplyLinkFormState } from "./utils/useApplyLinkFormState";
import { useScrollToTop } from "./utils/useScrollToTop";

// Every parameter a real link can carry, across all formats that are in the
// wild. `pid`/`cid`/`fids` are current; the rest predate them.
const INVITE_LINK_PARAMS = [
  "fids",
  "practiceFormId",
  "practiceformid",
  "formId",
  "formid",
  "pid",
  "practiceId",
  "practiceid",
  "cid",
  "chainId",
  "chainid",
];

export const InviteLayout = () => {
  useScrollToTop(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const applyLinkFormState = useApplyLinkFormState();
  // Links already in the wild predate `fids`: printed QR codes carry `formId`,
  // SMS short links carry `practiceFormId`. Neither ever expires.
  const legacyFormId =
    queryParams.get("practiceFormId") ||
    queryParams.get("practiceformid") ||
    queryParams.get("formId") ||
    queryParams.get("formid") ||
    undefined;
  const practiceFormIds = queryParams.get("fids") || legacyFormId || undefined;
  // A scanned link always brings its own parameters. Without any of them this
  // is an internal redirect, and resetting there would wipe the forms of the
  // patient who did scan.
  const arrivedThroughLink = INVITE_LINK_PARAMS.some((key) =>
    queryParams.has(key),
  );

  useEffect(() => {
    const handleInvite = async () => {
      setLoading(true);
      try {
        // Sessions now live in the tab only, so the store may not yet know one exists.
        clearPendingSmsLogin();
        clearPendingReleaseLogin();
        // Not useLogout: its loggingOut flag makes MainLayout remount this layout, which logs out again.
        await handleLogout();
        if (arrivedThroughLink) applyLinkFormState(practiceFormIds);
        navigate("/welcome", { replace: true });
      } finally {
        setLoading(false);
      }
    };
    handleInvite();
  }, [practiceFormIds, arrivedThroughLink, applyLinkFormState]);

  if (loading) {
    return;
  }

  return <LoadingScreen />;
};
